import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from 'kepler/lib/components/Modal';
import ModalBody from 'kepler/lib/components/ModalBody';
import i18n from '../../lib/reacti18n';
import {
  redirectToAppropriateChannel, closeStepUpContainer, initiateANWCheck, getRiskContactChannelName,
} from '../actions/action-step-up';
import { closeModalContainer } from '../actions/action-login-modal';
import doMobileWebHelpIvrAuth from '../actions/action-ivr-auth-web';
import { trackPage, trackLink } from '../../lib/analytics-helper';
import { REF_SELECT_RESULT } from '../constants/PropTypesShapes';
import { stepUpChannels } from '../constants/UtilVariables';

const labels = {
  yes: i18n.message('smarthelp/authStepUpPrompt.yes'),
  no: i18n.message('smarthelp/authStepUpPrompt.no'),
};

class StepUpContainer extends Component {
  constructor(props) {
    super(props);
    this.closeStepUpModal = this.closeStepUpModal.bind(this);
    this.getIntentVerbiage = this.getIntentVerbiage.bind(this);
    this.initiateANW = this.initiateANW.bind(this);

    // TODO:: This needs to be removed/refactored during clean up.
    // using local state to set contact channel in-order to reduce number of calls to getRiskContactChannelName function.
    this.state = {
      contactChannel: getRiskContactChannelName(this.props.fromChannel),
    };
  }

  componentDidMount() {
    if (this.props.redirectToChannel) {
      this.props.redirectToAppropriateChannel();
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      contactChannel: getRiskContactChannelName(nextProps.fromChannel),
    });
  }

  componentDidUpdate() {
    // On risk error/ anw error/ Risk decision Allow - we will redirect to final channel where the user has clicked.
    if (this.props.isRiskCheckError || this.props.isANWError || this.props.redirectToChannel) {
      this.props.redirectToAppropriateChannel();
    }

    if (this.props.anwUrl && typeof this.props.anwUrl === 'string') {
      window.location.href = this.props.anwUrl;
    }

    // On step-up modal open fire FPTI
    if (this.props.isModalOpen) {
      trackPage({ id: this.props.FPTI_StepUp_Id, link: `smarthelp-step-up|${this.getTopicRefId()}|${this.state.contactChannel}|open` });
    }
  }

  getIntentVerbiage() {
    const topicRefId = this.getTopicRefId();
    if (typeof topicRefId === 'string') {
      return i18n.message(`smarthelp/authStepUpPrompt.${topicRefId}`);
    }
    return '';
  }

  getTopicRefId() {
    if (this.props.selectResult && this.props.selectResult.topicRefId) {
      return this.props.selectResult.topicRefId;
    }

    return null;
  }

  closeStepUpModal(clickType) {
    // Firing FPTI on close of step up
    trackLink({ id: this.props.FPTI_StepUp_Id, link: `smarthelp-step-up|${this.getTopicRefId()}|${this.state.contactChannel}|${clickType}` });

    this.props.closeStepUpContainer({ redirectToChannel: true });
  }

  initiateANW() {
    trackLink({ id: this.props.FPTI_StepUp_Id, link: `smarthelp-step-up|${this.getTopicRefId()}|${this.state.contactChannel}|yes` });

    // This is to reset fromChannel of intermediate modal from logged out to logged in case
    this.props.closeModalContainer();

    // Fire StepUp Mayfly context for callUs channel
    if (this.state.contactChannel === stepUpChannels.call) {
      this.props.doMobileWebHelpIvrAuth();
    }

    // Initiate Auth Node Web call.
    this.props.initiateANWCheck();
  }

  render() {
    return (
      <div>
        <Modal isOpen={this.props.isModalOpen} type="dialog" width="medium" onCancel={() => this.closeStepUpModal('close')} backdropClosesModal={false}>
          <ModalBody>
            <div className="step-up-modal">
              <span className="step-up-message">{this.getIntentVerbiage()}</span>
              <div className="step-up-actions">
                <button className="vx_btn vx_btn-block" onClick={() => this.initiateANW()}>{labels.yes}</button>
                <button className="vx_btn vx_btn-secondary vx_btn-block" onClick={() => this.closeStepUpModal('no')}>{labels.no}</button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

StepUpContainer.propTypes = {
  isModalOpen: PropTypes.bool,
  redirectToChannel: PropTypes.bool,
  isRiskCheckError: PropTypes.bool.isRequired,
  closeStepUpContainer: PropTypes.func.isRequired,
  selectResult: PropTypes.shape(REF_SELECT_RESULT).isRequired,
  fromChannel: PropTypes.string,
  FPTI_StepUp_Id: PropTypes.string,
  initiateANWCheck: PropTypes.func.isRequired,
  anwUrl: PropTypes.string.isRequired,
  isANWError: PropTypes.bool.isRequired,
  closeModalContainer: PropTypes.func.isRequired,
  redirectToAppropriateChannel: PropTypes.func.isRequired,
  doMobileWebHelpIvrAuth: PropTypes.func.isRequired,
};

StepUpContainer.defaultProps = {
  FPTI_StepUp_Id: 'stepUpIntermediatePage',
  isModalOpen: false,
  redirectToChannel: false,
  fromChannel: '',
};

function mapStateToProps(state) {
  return {
    isModalOpen: state.stepUp.isModalOpen,
    selectResult: state.selectResult.topicTreeSelectResult,
    isRiskCheckError: state.stepUp.isRiskCheckError,
    isANWError: state.stepUp.anw.anwError,
    fromChannel: state.stepUp.fromChannel,
    redirectToChannel: state.stepUp.redirectToChannel,
    anwUrl: state.stepUp.anw.anwUrl,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    closeStepUpContainer,
    initiateANWCheck,
    closeModalContainer,
    redirectToAppropriateChannel,
    doMobileWebHelpIvrAuth,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StepUpContainer);
